/* ============
 * All Product Types
 * ============
 *
 * All product recommendations.
 */

import Vue from 'vue';
import store from './../../store';
import productRecommendationTransformer from './../../transformers/productRecommendation';

const success = ({ data }, resolve) => {
  const productRecommendations = productRecommendationTransformer.fetchCollection(data.data);
  store.dispatch('fetchAllProductRecommendations', productRecommendations);
  resolve();
};

const failed = (error, reject) => reject(error);

// Display product recommendations.
export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('product_recommendations')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/productRecommendation/all.js